
import { putTags } from '../api/putTags';
import { setGetTags } from './setGetTags';

export const setPutTags = (params) => {
    return async (dispatch, getState) => {
        try {
            const { data } = await putTags(params);

            dispatch(setGetTags({user_id: params.user_id}));
            alert('удален')
        } catch (error) {
            if (error?.response?.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}